<template>
  <div class="text-center text-sm text-gray-600 mt-4 opacity-70 relative z-10">
      By continuing, you agree with our
      <a href="/terms-and-conditions" class="text-indigo-600 hover:text-indigo-500">Terms & Conditions</a>
      and
      <a href="/privacy-policy" class="text-indigo-600 hover:text-indigo-500">Privacy and Cookie Policy</a>.
    </div>
</template>